// prod
export const s3Config = {
    bucketName: "bayin",
    dirName: "category",
    region: "us-east-1",
   accessKeyId: 'AKIASEVRSUZK33PGAR5G',
     secretAccessKey: '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',
  };

// stagging
// export const s3Config = {
//   bucketName: "mobileapplications",
//   dirName: "category",
//   region: "ap-south-1",
//   accessKeyId: "AKIAQKGGXOAW2UAIWZX4",
//   secretAccessKey: "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",
// };

window.Buffer = window.Buffer || require("buffer").Buffer;
